import styled from "styled-components";
import {UserMenuSectionBox} from "../../user-menu/user-menu/boxes/user-menu-section.box";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const UsefulLinksSectionDefaultBox = styled(UserMenuSectionBox)`
    margin-top: 2rem;
    padding: 2.5rem 1rem 1rem 1rem;
`;

/* 777 */
const UsefulLinksSectionCasino777Box = styled(UserMenuSectionBox)`
    margin: 5rem 0 0 0;
    padding: 2.5rem 1rem 1rem 1rem;
`;

/* harrahs */
/* wsop */
const UsefulLinksSectionHarrahsWsopBox = styled(UserMenuSectionBox)`
    margin-top: 3rem;
    padding: 1rem;
`;

export const UsefulLinksSectionBox = styledByTheme(UsefulLinksSectionDefaultBox)
    .forCasino777(UsefulLinksSectionCasino777Box)
    .forHarrahs(UsefulLinksSectionHarrahsWsopBox)
    .forWsop(UsefulLinksSectionHarrahsWsopBox)
    .apply();
